import { AdsController, NullAdsController } from "@mp-commons/modules/ads/AdsController.js";
import { GDPRPromise, GDPRSdk } from "@mp-commons/modules/ads/GDPR.js";
import { AbstractImaController } from "@mp-commons/modules/ads/ima/AbstractImaController.js";
import { loadImaSdk } from "@mp-commons/modules/ads/ima/ImaLoader.js";

export function ImaControllerBuilder<A extends AbstractImaController>(builder: (ima: typeof google.ima, gdpr: GDPRSdk) => A, debug: boolean = true): Promise<AdsController> {

    return loadImaSdk(window,debug).then(ima => {
        return GDPRPromise().then(gdpr => {
            return builder(ima,gdpr);
        });
    }).catch(err => {
        console.error("ERROR LOADING IMA ",err);
        return Promise.resolve(new NullAdsController());
    });

}